const config = {
    ENV: 'DEVELOPMENT',
    apiEndpoint: '/api/',
    languages: ['ka', 'en'],
    recaptchaSiteKey: '6LeHfhAaAAAAAE4Vn1bqohpK6jdy6MZx14O3KKnc',
    ramadUrl: 'http://ramad-dev.bog.ge/s3/research',
    ssoSdkUrl: 'https://account-test.bog.ge/ssosdk/sdk.js',
    mapApiUrl: 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyDUIbdWtQOG9R6FuiWOQpLbplWhrsJii-A&callback=Function.prototype',
    mapMarkerUrl: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js',
};

export default config;
